import { lazy } from "react";
import { RouteObject } from "react-router-dom";

// Blog Posts
import BecomingPost from "../pages/blog/books/becoming";
import GiftsOfImperfectionPost from "../pages/blog/books/gifts-of-imperfection";
import UntamedPost from "../pages/blog/books/untamed";
import WomenWhoRunPost from "../pages/blog/books/women-who-run";
import BeautyStandardsPost from "../pages/blog/posts/beauty-standards";
import BudgetTravelTipsPost from "../pages/blog/posts/budget-travel-tips";
import DailyHabitsPost from "../pages/blog/posts/daily-habits";
import FearToFreedomPost from "../pages/blog/posts/fear-to-freedom";
import IranWomenRightsPost from "../pages/blog/posts/iran-women-rights";
import IstanbulConventionPost from "../pages/blog/posts/istanbul-convention";
import LaserTreatmentsPost from "../pages/blog/posts/laser-treatments";
import MentalHealthWomenPost from "../pages/blog/posts/mental-health-women";
import MothersWisdomPost from "../pages/blog/posts/mothers-wisdom";
import NegotiatingWorthPost from "../pages/blog/posts/negotiating-worth";
import SelfCarePost from "../pages/blog/posts/self-care";
import SettingBoundariesPost from "../pages/blog/posts/setting-boundaries";
import SoloTravelSafetyPost from "../pages/blog/posts/solo-travel-safety";
import SoloDestinationsPost from "../pages/blog/posts/solo-destinations";
import USReproductiveRightsPost from "../pages/blog/posts/us-reproductive-rights";
import SkincareQAPost from "../pages/blog/posts/skincare-qa";
import SkincareRoutinePost from "../pages/blog/posts/skincare-routine";
import TransWomenRightsLuxembourg from "../pages/blog/posts/trans-women-rights-luxembourg";
import RuralWomenChallenges from "../pages/blog/posts/rural-women-challenges";
import GlobalTransRights2024 from "../pages/blog/posts/global-trans-rights-2024";
import EmergencyShelterLuxembourgPost from "../pages/blog/posts/emergency-shelter-luxembourg";
import EmergencyShelterTurkeyPost from "../pages/blog/posts/emergency-shelter-turkey";
import FeministTermsGlossary from "../pages/blog/posts/feminist-terms-glossary";
import GazaCrisis2025Post from "../pages/blog/posts/gaza-crisis-2025";
import WomenChildrenWarPost from "../pages/blog/posts/women-children-war";

import LuxembourgLeaders from "../pages/blog/women-leaders/luxembourg-leaders";
import TurkeyLeaders from "../pages/blog/women-leaders/turkey-leaders";

const HomePage = lazy(() => import("../pages/home/page"));
const StoryPage = lazy(() => import("../pages/story/page"));
const CommunityPage = lazy(() => import("../pages/community/page"));
const SafetyPage = lazy(() => import("../pages/safety/page"));
const StructuralViolencePage = lazy(() => import("../pages/blog/posts/structural-violence"));
const ShopPage = lazy(() => import("../pages/shop/page"));
const BlogPage = lazy(() => import("../pages/blog/page"));
const OrdersPage = lazy(() => import("../pages/orders/page"));
const AdminPage = lazy(() => import("../pages/admin/page"));
const AdminPetitionSignaturesPage = lazy(() => import("../pages/admin/petition-signatures/page"));
const ContentAdminPage = lazy(() => import("../pages/content-admin/page"));
const NotFoundPage = lazy(() => import("../pages/NotFound"));
const TransformationPage = lazy(() => import("../pages/transformation/page"));

// Digital Shop Pages - only the main page now
const DigitalShopPage = lazy(() => import("../pages/digital-shop/page"));

// Blog posts (lazy)
const DailyHabits = lazy(() => import("../pages/blog/posts/daily-habits"));
const FearToFreedom = lazy(() => import("../pages/blog/posts/fear-to-freedom"));
const MothersWisdom = lazy(() => import("../pages/blog/posts/mothers-wisdom"));
const NegotiatingWorth = lazy(() => import("../pages/blog/posts/negotiating-worth"));
const SelfCare = lazy(() => import("../pages/blog/posts/self-care"));
const SettingBoundaries = lazy(() => import("../pages/blog/posts/setting-boundaries"));
const SoloTravelSafety = lazy(() => import("../pages/blog/posts/solo-travel-safety"));
const BudgetTravelTips = lazy(() => import("../pages/blog/posts/budget-travel-tips"));
const SoloDestinations = lazy(() => import("../pages/blog/posts/solo-destinations"));
const IstanbulConvention = lazy(() => import("../pages/blog/posts/istanbul-convention"));
const IranWomenRights = lazy(() => import("../pages/blog/posts/iran-women-rights"));
const USReproductiveRights = lazy(() => import("../pages/blog/posts/us-reproductive-rights"));
const BeautyStandards = lazy(() => import("../pages/blog/posts/beauty-standards"));
const SkincareQA = lazy(() => import("../pages/blog/posts/skincare-qa"));
const LaserTreatments = lazy(() => import("../pages/blog/posts/laser-treatments"));
const SkincareRoutine = lazy(() => import("../pages/blog/posts/skincare-routine"));
const MentalHealthWomen = lazy(() => import("../pages/blog/posts/mental-health-women"));

// Book pages (lazy)
const BecomingBook = lazy(() => import("../pages/blog/books/becoming"));
const UntamedBook = lazy(() => import("../pages/blog/books/untamed"));
const GiftsOfImperfectionBook = lazy(() => import("../pages/blog/books/gifts-of-imperfection"));
const WomenWhoRunBook = lazy(() => import("../pages/blog/books/women-who-run"));

// Grandmothers' Stories (lazy)
const GrandmothersStoriesPage = lazy(() => import("../pages/blog/grandmothers-stories/page"));
const NeclaStory = lazy(() => import("../pages/blog/grandmothers-stories/necla-story"));
const SengulStory = lazy(() => import("../pages/blog/grandmothers-stories/sengul-story"));

const DonatePage = lazy(() => import("../pages/donate/page"));
const SuccessStoriesPage = lazy(() => import("../pages/success-stories/page"));
const VolunteerPage = lazy(() => import("../pages/volunteer/page"));
const ResourcesPage = lazy(() => import("../pages/resources/page"));
const PartnersPage = lazy(() => import("../pages/partners/page"));

const LifeSimulatorPage = lazy(() => import('../pages/life-simulator/page'));
const SkillsTranslatorPage = lazy(() => import('../pages/skills-translator/page'));

const DemandsPage = lazy(() => import('../pages/demands/page'));
const StudentCommunityPage = lazy(() => import('../pages/student-community/page'));

const HealthPage = lazy(() => import('../pages/health/page'));
const WellnessPage = lazy(() => import('../pages/wellness/page'));

import StructuralViolence from '../pages/blog/posts/structural-violence';
import DigitalViolence from '../pages/blog/posts/digital-violence';
import NorthKoreaWomenRights from '../pages/blog/posts/north-korea-women-rights';
import BreastCancerAwareness from '../pages/blog/posts/breast-cancer-awareness';
import HopeInDarkness from '../pages/blog/posts/hope-in-darkness';
import InstagramAccountsForGirlies from '../pages/blog/posts/instagram-accounts-for-girlies';
import DisabledWomenTurkeyLuxembourg from '../pages/blog/posts/disabled-women-turkey-luxembourg';

const routes: RouteObject[] = [
  {
    path: "/",
    element: <HomePage />,
  },
  {
    path: "/story",
    element: <StoryPage />,
  },
  {
    path: "/community",
    element: <CommunityPage />,
  },
  {
    path: "/safety",
    element: <SafetyPage />,
  },
  {
    path: "/blog/structural-violence",
    element: <StructuralViolencePage />,
  },
  {
    path: "/shop",
    element: <ShopPage />,
  },
  {
    path: "/digital-shop",
    element: <DigitalShopPage />,
  },
  {
    path: "/orders",
    element: <OrdersPage />,
  },
  {
    path: "/admin",
    element: <AdminPage />,
  },
  {
    path: "/admin/petition-signatures",
    element: <AdminPetitionSignaturesPage />,
  },
  {
    path: "/content-admin",
    element: <ContentAdminPage />,
  },
  {
    path: "/blog",
    element: <BlogPage />,
  },
  {
    path: "/transformation",
    element: <TransformationPage />,
  },
  {
    path: "/blog/daily-habits",
    element: <DailyHabits />,
  },
  {
    path: "/blog/fear-to-freedom",
    element: <FearToFreedom />,
  },
  {
    path: "/blog/mothers-wisdom",
    element: <MothersWisdom />,
  },
  {
    path: "/blog/negotiating-worth",
    element: <NegotiatingWorth />,
  },
  {
    path: "/blog/self-care",
    element: <SelfCare />,
  },
  {
    path: "/blog/setting-boundaries",
    element: <SettingBoundaries />,
  },
  {
    path: "/blog/solo-travel-safety",
    element: <SoloTravelSafety />,
  },
  {
    path: "/blog/budget-travel-tips",
    element: <BudgetTravelTips />,
  },
  {
    path: "/blog/solo-destinations",
    element: <SoloDestinations />,
  },
  {
    path: "/blog/istanbul-convention",
    element: <IstanbulConvention />,
  },
  {
    path: "/blog/iran-women-rights",
    element: <IranWomenRights />,
  },
  {
    path: "/blog/us-reproductive-rights",
    element: <USReproductiveRights />,
  },
  {
    path: "/blog/beauty-standards",
    element: <BeautyStandards />,
  },
  {
    path: "/blog/skincare-qa",
    element: <SkincareQA />,
  },
  {
    path: "/blog/laser-treatments",
    element: <LaserTreatments />,
  },
  {
    path: "/blog/skincare-routine",
    element: <SkincareRoutine />,
  },
  {
    path: "/blog/mental-health-women",
    element: <MentalHealthWomen />,
  },
  {
    path: "/blog/trans-women-rights-luxembourg",
    element: <TransWomenRightsLuxembourg />,
  },
  {
    path: "/blog/rural-women-challenges",
    element: <RuralWomenChallenges />,
  },
  {
    path: "/blog/global-trans-rights-2024",
    element: <GlobalTransRights2024 />,
  },
  {
    path: "/blog/books/becoming",
    element: <BecomingBook />,
  },
  {
    path: "/blog/books/untamed",
    element: <UntamedBook />,
  },
  {
    path: "/blog/books/gifts-of-imperfection",
    element: <GiftsOfImperfectionBook />,
  },
  {
    path: "/blog/books/women-who-run",
    element: <WomenWhoRunBook />,
  },
  {
    path: "/blog/grandmothers-stories",
    element: <GrandmothersStoriesPage />,
  },
  {
    path: "/blog/grandmothers-stories/necla-story",
    element: <NeclaStory />,
  },
  {
    path: "/blog/grandmothers-stories/sengul-story",
    element: <SengulStory />,
  },
  {
    path: "/donate",
    element: <DonatePage />,
  },
  {
    path: "/success-stories",
    element: <SuccessStoriesPage />,
  },
  {
    path: "/volunteer",
    element: <VolunteerPage />,
  },
  {
    path: "/resources",
    element: <ResourcesPage />,
  },
  {
    path: "/partners",
    element: <PartnersPage />,
  },
  {
    path: "/life-simulator",
    element: <LifeSimulatorPage />,
  },
  {
    path: "/skills-translator",
    element: <SkillsTranslatorPage />,
  },
  {
    path: '/blog/women-leaders/luxembourg',
    element: <LuxembourgLeaders />,
  },
  {
    path: '/blog/women-leaders/luxembourg-leaders',
    element: <LuxembourgLeaders />,
  },
  {
    path: '/blog/women-leaders/turkey',
    element: <TurkeyLeaders />,
  },
  {
    path: '/blog/women-leaders/turkey-leaders',
    element: <TurkeyLeaders />,
  },
  {
    path: '/demands',
    element: <DemandsPage />,
  },
  {
    path: '/student-community',
    element: <StudentCommunityPage />,
  },
  {
    path: '/health',
    element: <HealthPage />,
  },
  {
    path: '/health/topics/menstrual-health',
    element: lazy(() => import('../pages/health/topics/menstrual-health-expanded'))
  },
  {
    path: '/health/topics/pregnancy-fertility',
    element: lazy(() => import('../pages/health/topics/pregnancy-fertility-expanded'))
  },
  {
    path: '/health/topics/sexual-health',
    element: lazy(() => import('../pages/health/topics/sexual-health'))
  },
  {
    path: '/health/topics/mental-health',
    element: lazy(() => import('../pages/health/topics/mental-health'))
  },
  {
    path: '/health/topics/gynecological-health',
    element: lazy(() => import('../pages/health/topics/gynecological-health'))
  },
  {
    path: '/health/topics/hormones-menopause',
    element: lazy(() => import('../pages/health/topics/hormones-menopause'))
  },
  {
    path: '/health/topics/breast-health',
    element: lazy(() => import('../pages/health/topics/breast-health'))
  },
  {
    path: '/health/topics/finding-healthcare',
    element: lazy(() => import('../pages/health/topics/finding-healthcare'))
  },
  {
    path: '/wellness',
    element: <WellnessPage />,
  },
  {
    path: '/blog/structural-violence',
    element: <StructuralViolence />
  },
  {
    path: '/blog/digital-violence',
    element: <DigitalViolence />
  },
  {
    path: "/blog/north-korea-women-rights",
    element: <NorthKoreaWomenRights />,
  },
  {
    path: '/blog/emergency-shelter-luxembourg',
    element: <EmergencyShelterLuxembourgPost />
  },
  {
    path: '/blog/emergency-shelter-turkey',
    element: <EmergencyShelterTurkeyPost />
  },
  {
    path: "/blog/gaza-crisis-2025",
    element: <GazaCrisis2025Post />,
  },
  {
    path: "/blog/women-children-war",
    element: <WomenChildrenWarPost />,
  },
  {
    path: "/blog/feminist-terms-glossary",
    element: <FeministTermsGlossary />,
  },
  {
    path: '/blog/instagram-accounts-for-girlies',
    element: <InstagramAccountsForGirlies />,
  },
  {
    path: '/blog/breast-cancer-awareness',
    element: <BreastCancerAwareness />,
  },
  {
    path: "/blog/disabled-women-turkey-luxembourg",
    element: <DisabledWomenTurkeyLuxembourg />,
  },
  {
    path: "/blog/hope-in-darkness",
    element: <HopeInDarkness />,
  },
  {
    path: "*",
    element: <NotFoundPage />,
  }
];

export default routes;
